var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _radialGradient17, _radialGradient18, _radialGradient19, _radialGradient20, _radialGradient21, _radialGradient22, _radialGradient23, _radialGradient24, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIrelandLottoPlus2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 36.393,
    cy: 15.033,
    r: 6.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    stopColor: "#fefbf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144,
    stopColor: "#fceeea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#f7d9d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308,
    stopColor: "#f2bcab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#ea977d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    stopColor: "#e16944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#d63402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#d63300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    stopColor: "#d52d02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#d21d09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    stopColor: "#cc0213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#cc0014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#c60014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#ba0014"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 25.247,
    cy: 8.683,
    r: 3.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.081,
    stopColor: "#fefefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#fcfbef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#f8f7db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#f3f0c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#ede89c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#e5de73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#e0dc6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529,
    stopColor: "#d3d55d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#bdcb42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#b0c532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#aac02f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#99b227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#809e1c"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 13.82,
    cy: 9.983,
    r: 4.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#fffdf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#fff8e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#ffefc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ffe498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#ffd45f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#ffc21a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#fdbc1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#f6ac26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#f5aa27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#efa627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e09c27"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 6.297,
    cy: 16.317,
    r: 3.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.088,
    stopColor: "#f0fafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    stopColor: "#c9ecf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#8bd6e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#78cfdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#50b0c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#339bba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2993b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#238daf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#147d9e"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 2.636,
    cy: 24.708,
    r: 3.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.081,
    stopColor: "#fefefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#fcfbef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#f8f7db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#f3f0c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#ede89c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#e5de73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#e0dc6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529,
    stopColor: "#d3d55d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#bdcb42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#b0c532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#aac02f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#99b227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#809e1c"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 15.248,
    cy: 27.857,
    r: 12.332,
    gradientTransform: "matrix(.9502 -.3115 .1377 .4202 -3.078 20.902)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#cfd30c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#c3ce0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#a2c112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 16.305,
    cy: 27.074,
    r: 7.158,
    gradientTransform: "matrix(.6867 -.727 .3563 .3366 -4.538 29.815)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#f8e954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#e5df32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#d5d616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#cfd30c"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 34.571,
    cy: 29.094,
    r: 6.754,
    gradientTransform: "matrix(.9681 -.2506 .0991 .3828 -1.78 26.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#b6c90a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#aac40e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 26.612,
    cy: 26.191,
    r: 4.796,
    gradientTransform: "matrix(.7514 .6599 -.2395 .2727 12.888 1.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#a6cc05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#a0c210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 32.851,
    cy: 48.428,
    r: 0.845,
    gradientTransform: "matrix(.9649 -.2627 1.2057 4.4285 -57.236 -157.404)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#72a61d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 34.427,
    cy: 44.718,
    r: 1.669,
    gradientTransform: "matrix(.9767 -.2145 .6725 3.0631 -29.274 -84.876)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#86b41b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 22.888,
    cy: 47.471,
    r: 10.216,
    gradientTransform: "matrix(.9569 .2906 -.1117 .3677 6.288 23.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#88b41a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#94ba16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 9.163,
    cy: 43.668,
    r: 7.746,
    gradientTransform: "matrix(.7543 -.6566 .2967 .3409 -10.705 34.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#86b51c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#92ba17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 10.181,
    cy: 42.84,
    r: 4.916,
    gradientTransform: "matrix(.7286 -.6849 .1703 .1811 -4.53 42.054)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#94bb1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#88b61c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#86b51c"
  }))), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 19.841,
    cy: 48.502,
    r: 15.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#9fc012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#2e6213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#3a6c13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#5b8713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#90b312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 35.405,
    cy: 38.48,
    r: 3.594,
    fx: 34.843,
    fy: 38.442,
    gradientTransform: "matrix(.9639 .2662 -1.6172 5.8566 63.508 -196.308)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#5c9136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#689a2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#89b01e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 29.047,
    cy: 27.143,
    r: 12.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#82b11f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#8eb719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 19.736,
    cy: 31.173,
    r: 6.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#bcca1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#9eb421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#73962a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#8aac1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#9abb15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient19 || (_radialGradient19 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: 26.863,
    cy: 30.631,
    r: 5.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcca1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#9eb421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#73962a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#8aac1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9abb15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fc012"
  }))), _radialGradient20 || (_radialGradient20 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: 19.796,
    cy: 34.301,
    r: 0.965,
    gradientTransform: "matrix(.9923 -.124 .4301 3.4431 -14.6 -81.347)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#626f54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5d6952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#4e594c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#4b554b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#484f46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#3f3f37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.978,
    stopColor: "#3e3c35"
  }))), _radialGradient21 || (_radialGradient21 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 24.445,
    cy: 42.059,
    r: 5.519,
    gradientTransform: "matrix(1 0 0 .412 0 24.729)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#669b1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#477614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b6811"
  }))), _radialGradient22 || (_radialGradient22 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: 19.18,
    cy: 31.215,
    r: 0.909,
    gradientTransform: "matrix(.9183 -.3958 .4818 1.1179 -13.473 3.913)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#e6e8e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#d2d6ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#b8beb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#99a18f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#747f67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#626f54"
  }))), _radialGradient23 || (_radialGradient23 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: 26.649,
    cy: 33.738,
    r: 0.896,
    gradientTransform: "matrix(.9907 -.1362 .5259 3.8247 -17.494 -91.668)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#626f54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5d6952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#4e594c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#4b554b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#484f46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#3f3f37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.978,
    stopColor: "#3e3c35"
  }))), _radialGradient24 || (_radialGradient24 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 26.149,
    cy: 30.844,
    r: 0.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#e6e8e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#d2d6ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#b8beb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#99a18f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#747f67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#626f54"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.381 17.875c5.109 0 9.262 4.116 9.262 9.171s-4.152 9.171-9.262 9.171c-5.127 0-9.28-4.098-9.28-9.171.018-5.055 4.152-9.171 9.28-9.171z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.709 7.421c3.845 0 6.987 3.087 6.987 6.897s-3.123 6.897-6.987 6.897c-3.845 0-6.969-3.087-6.969-6.897s3.123-6.897 6.969-6.897z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.272 10.527c3.412 0 6.192 2.744 6.192 6.138s-2.78 6.138-6.192 6.138c-3.43 0-6.211-2.744-6.211-6.138s2.78-6.138 6.211-6.138z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.334 22.966c2.961 0 5.362 2.383 5.362 5.308 0 2.943-2.401 5.308-5.362 5.308s-5.362-2.383-5.362-5.308c-.018-2.925 2.383-5.308 5.362-5.308z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.907 38.203c2.509 0 4.55 2.022 4.55 4.495 0 2.491-2.04 4.495-4.55 4.495s-4.55-2.022-4.55-4.495c-.018-2.473 2.022-4.495 4.55-4.495z",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m13.351 55.968 24.301-5.849s2.618-2.69 4.333-9.424c1.697-6.734 1.589-9.063 1.589-9.063s.668-.524 1.083-.162S60.31 46.13 60.31 46.13l26.575-.524s.253.415.054 1.192-2.166 5.759-6.229 10.67c-4.08 4.911-7.835 8.395-7.835 8.395s-.722.415-.668 1.498.162 1.823.975 5.127c.83 3.322 1.083 8.594.469 11.555s-1.805 7.98-2.112 8.395-.578-.162-1.137-.722c-.578-.578-6.337-5.344-10.399-8.341s-8.901-6.012-9.532-6.174c-.614-.144-7.673 1.462-9.839 2.13s-7.926 1.029-11.536 1.192h-7.98s-.469-.614.144-1.047c.614-.415 4.026-4.983 5.868-7.817 1.86-2.853 2.943-4.658 2.834-5.29s-3.809-3.412-8.648-5.741c-4.82-2.329-8.792-4.044-7.962-4.658z",
    fill: "#9fc012"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.413 56.582s7.42 2.907 19.986 2.022 17.296-7.258 17.404-12.331S44.458 31.505 44.26 33.166c-.217 1.661-2.618 15.075-6.211 17.332-3.611 2.275-24.337 4.477-20.636 6.084z",
    fill: "url(#f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.263 53.134s7.944-.849 10.814-2.708c2.889-1.86 5.001-10.2 5.254-12.132.253-1.914 3.557-1.3 2.889 5.705s-3.9 8.63-9.659 9.298-9.081.506-9.298-.162z",
    fill: "url(#g)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.223 47.447s.469.704-7.745 4.838-10.796 2.762-11.898 2.329-5.506-3.557-2.473-5.416c3.051-1.86 22.369-3.575 22.116-1.751z",
    fill: "url(#h)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m60.634 50.516-8.341-10.923c-.469-1.155 7.853 8.269 8.269 7.872.415-.379 4.026-1.264 3.502-.325-.506.939-1.751 1.21-2.473 2.383-.722 1.155-.776 1.354-.957.993z",
    fill: "url(#i)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.538 92.437s-1.823-5.922-4.225-10.616c-1.426-2.798 2.6-4.207 3.701 1.047.776 3.665.542 6.138.524 8.106v1.462z",
    fill: "url(#j)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.297 86.389s-.054-5.705-1.751-10.471-1.228-7.059-.199-6.481 2.961 3.918 3.033 9.695c.09 5.759-.812 8.016-1.083 7.258z",
    fill: "url(#k)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m67.837 87.924-12.259-9.009c-4.116-2.491-5.001-2.6-6.229-2.329-1.246.253-10.814 1.661-12.62 1.914s-3.304.162-3.304.162l13.595-3.015c5.001-.885 13.035 1.805 15.869 4.189 2.834 2.401 5.2 5.976 4.947 8.088z",
    fill: "url(#l)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.394 64.616s9.496 3.629 8.684 7.204c-.83 3.575-5.976 7.528-9.334 8.251-3.34.722-8.196.506-7.384-.379.83-.885 8.287-10.255 8.233-12.277s-2.203-3.214-.199-2.798z",
    fill: "url(#m)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.36 79.691s8.395-7.258 9.009-9.894 5.813-1.246 3.593 2.076-7.438 7.492-9.875 8.088-3.972.56-3.611.307l.885-.578z",
    fill: "url(#n)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.049 60.012a22.604 22.604 0 0 1 4.315 1.228c6.644 2.582 8.648 4.243 7.565 6.626s-5.38 8.883-7.962 10.995c-.722.596-1.751 1.119-2.889 1.553-.108-.181-.271-.632.199-.957.614-.415 4.026-4.983 5.868-7.817 1.86-2.853 2.943-4.658 2.834-5.29s-3.809-3.412-8.648-5.741l-1.282-.596z",
    fill: "#81b31d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.114 80.522s6.391-.054 13.486-.993c7.113-.939 14.154-2.907 16.573-2.546s10.562 6.319 13.486 8.901c2.528 2.239 5.543 4.658 6.86 6.499-.325.433-.596-.144-1.155-.704-.578-.578-6.337-5.344-10.399-8.341s-8.901-6.012-9.532-6.174c-.614-.144-7.673 1.462-9.839 2.13s-7.926 1.029-11.536 1.192c-3.557.199-7.944.036-7.944.036z",
    fill: "url(#o)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.542 84.457c.144-2.654.162-5.615-.289-7.619l-2.04-10.182c-.108-1.137 1.029-1.715 3.502-4.044s8.413-9.496 10.056-11.988a39.717 39.717 0 0 0 2.004-3.412c-.56 1.517-2.509 5.886-6.084 10.219-4.08 4.911-7.835 8.395-7.835 8.395s-.722.415-.668 1.498.162 1.823.975 5.127c.83 3.322 1.083 8.594.469 11.555a3.99 3.99 0 0 1-.09.451z",
    fill: "url(#p)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m86.884 45.605-17.44 1.155c-4.947-.072-8.413 0-8.413 0s-.018 1.011-.758.596S46.137 33.581 45.757 32.48l14.551 13.631 26.575-.506z",
    fill: "url(#q)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.959 36.344c.036.83-.036 1.932-.289 3.412-.903 5.254-2.582 9.677-5.344 10.832-2.311.975-7.908 2.329-10.562 2.13L37.632 50.1s2.618-2.69 4.333-9.424l.993-4.333z",
    fill: "#a0b936"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.295 51.166s-1.48.885-1.517 2.672c-.018 1.787.199 3.918.849 7.131.668 3.214 1.715 4.73 3.647 4.207 1.932-.506 1.805-3.502 1.553-7.908-.253-4.387-2.509-6.806-4.532-6.102z",
    fill: "url(#r)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M56.734 50.317s-1.426.614-1.444 2.401c-.018 1.805.614 4.405 1.047 7.492s1.498 4.73 3.448 4.225c1.968-.524 1.841-3.521 1.571-7.962-.271-4.423-2.564-6.86-4.622-6.156z",
    fill: "url(#s)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.782 52.719s-.632.361-.596 1.968.361 4.152.632 6.879c.271 2.708 1.155 4.225 2.455 3.755 1.3-.451 1.119-3.141.812-7.095-.307-3.972-1.932-6.156-3.304-5.506z",
    fill: "url(#t)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42.237 68.534s.704-.289 1.029-.162c.343.126 4.152 1.571 9.912 1.625 5.777.054 9.532-.758 10.2-.957s1.444.036 1.39.181-.307.108-1.517.794c-1.21.704-3.701 3.521-9.081 3.394s-7.33-2.004-9.009-3.015-1.823-1.3-2.528-1.444-.397-.415-.397-.415z",
    fill: "url(#u)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.414 52.737c.668 0 1.21.65 1.21 1.462 0 .794-.542 1.444-1.21 1.444s-1.21-.65-1.21-1.444c0-.812.542-1.462 1.21-1.462z",
    fill: "url(#v)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.258 51.834s-.632.361-.596 1.968.361 4.152.632 6.86c.271 2.726 1.155 4.225 2.455 3.755 1.3-.451 1.137-3.141.812-7.095s-1.95-6.12-3.304-5.488z",
    fill: "url(#w)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M57.872 51.852c.668 0 1.21.65 1.21 1.444s-.542 1.444-1.21 1.444-1.21-.65-1.21-1.444.542-1.444 1.21-1.444z",
    fill: "url(#x)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M47.87 70.231c2.076.379 6.03.867 11.609 0 1.841-.289 3.177-.379 4.116-.397.921-.506 1.137-.469 1.174-.614.054-.162-.722-.397-1.39-.181s-4.423 1.011-10.2.957c-5.759-.054-9.569-1.498-9.912-1.625-.343-.144-1.029.162-1.029.162s-.307.289.397.433.849.433 2.528 1.444c.939.56 1.986 1.408 3.665 2.058-1.498-1.21-2.582-2.546-.957-2.239z",
    fill: "#3b6811"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrelandLottoPlus2);
export default __webpack_public_path__ + "static/media/ireland_lotto_plus_2.381b9163911a85f333e4733444e7b3c0.svg";
export { ForwardRef as ReactComponent };